export const CONDITION_DETAIL = [
  {
    name   : 'Brand New',
    detail : 'adalah produk yang tidak pernah dipakai dan disertai dengan tag/label pembelian yang asli. Tidak ada kerusakan apapun.'

  },
  {
    name   : 'Perfect',
    detail : 'adalah produk yang tidak pernah dipakai, namun tanpa tag/label pembelian. Tidak ada kerusakan apapun dan dalam keadaan sempurna.'

  },
  {
    name   : 'Good',
    detail : 'adalah produk yang pernah dipakai (preloved) namun sangat terawat. Kerusakan kecil akan diinformasikan di keterangan produk masing-masing.'
  }
]
